<template>
    <!-- Main Sidebar Container -->
    <aside class="main-sidebar sidebar-dark-primary elevation-4" style="background-color:#0a4fa2; color:white">
        <!-- Brand Logo -->
        <router-link class="brand-link" style="border-bottom: unset;" to="/">
            <span class="brand-text font-weight-light">
                <img src="/logo/sbswhite_transp.png" style="padding:10px 30px" width="100%">
            </span>
        </router-link>

        <!-- Sidebar -->
        <div class="sidebar">
            <!-- Sidebar Menu -->
            <nav class="mt-3" style="margin-bottom: 100px">
                <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu"
                    data-accordion="false">
                    <li class="nav-item has-treeview" v-if="permissions.studentsMenu">
                        <a class="nav-link">
                            <i class="nav-icon fas fa-graduation-cap"></i>
                            <p>
                                {{$t('sidebar.student.name')}}
                                <i class="right fa fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="permissions.createStudents">
                                <router-link :to="{name: 'StudentCreate'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.student.create')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewStudents">
                                <router-link :to="{name: 'StudentIndex'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.student.list')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewStudentsImported">
                                <router-link class="nav-link" :to="{name: 'StudentImportIndex'}"><i
                                        class="far fa-dot-circle nav-icon"></i>
                                        <p>{{$t('sidebar.import.list')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewStudentsContacts">
                                <router-link :to="{name: 'StudentContactView'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.student.contact')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewStudentsTranscripts">
                                <router-link :to="{name: 'StudentTranscriptIndex'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.student.transcript')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.createStudentsEnrollment">
                                <router-link :to="{name: 'StudentEnrollmentCreate'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.student.enrollmentReport')}}</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-item has-treeview" v-if="permissions.alumniMenu">
                        <a class="nav-link">
                            <i class="nav-icon fas fa-user-graduate"></i>
                            <p>
                                {{$t('sidebar.alumni.name')}}
                                <i class="right fa fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview" style="display:none">
                            <li class="nav-item" v-if="permissions.viewAlumni">
                                <router-link :to="{name:'AlumniIndex'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.alumni.list')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewAlumniTranscripts">
                                <router-link :to="{name: 'AlumniTranscriptIndex'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.alumni.transcript')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewAlumniContacts">
                                <router-link :to="{name: 'AlumniContactView'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.student.contact')}}</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-item has-treeview" v-if="permissions.employeeMenu || partnerID == 1">
                        <a class="nav-link">
                            <i class="nav-icon fa fa-edit"></i>
                            <p>
                                {{$t('sidebar.employee.name')}}
                                <i class="fa fa-angle-left right"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="permissions.createEmployeeProfessors">
                                <router-link :to="{name: 'ProfessorCreate'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.employee.professor.create')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewEmployeeProfessors">
                                <router-link :to="{name: 'ProfessorIndex'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.employee.professor.list')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.createEmployeeStaff">
                                <router-link :to="{name: 'StaffCreate'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.employee.staff.create')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewEmployeeStaff">
                                <router-link :to="{name: 'StaffIndex'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.employee.staff.list')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.createEmployeeAbsences || partnerID == 1">
                                <router-link :to="{name: 'AbsenceCreate'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.employee.absenceAdd')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewEmployeeAbsences">
                                <router-link :to="{name: 'AbsenceIndex'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.employee.absence')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewEmployeeReasons">
                                <router-link :to="{name: 'ReasonIndex'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.employee.reason')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewEmployeeHolidays">
                                <router-link :to="{name: 'HolidayIndex'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.employee.holiday')}}</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-item has-treeview" v-if="permissions.programsMenu">
                        <a class="nav-link">
                            <i class="nav-icon fa fa-table"></i>
                            <p>
                                {{$t('sidebar.program.name')}}
                                <i class="fa fa-angle-left right"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="permissions.createPrograms">
                                <router-link :to="{name: 'ProgramCreate'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.program.create')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewPrograms">
                                <router-link :to="{name: 'ProgramIndex'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.program.list')}}</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-item has-treeview" v-if="permissions.companiesMenu">
                        <a class="nav-link">
                            <i class="nav-icon fas fa-file-invoice"></i>
                            <p>
                                {{$t('sidebar.company.name')}}
                                <i class="fa fa-angle-left right"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="permissions.createCompanies">
                                <router-link :to="{name: 'CompanyCreate'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.company.create')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewCompanies">
                                <router-link :to="{name: 'CompanyIndex'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.company.list')}}</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-item has-treeview" v-if="permissions.coursesMenu">
                        <a class="nav-link">
                            <i class="nav-icon fas fa-chalkboard-teacher"></i>
                            <p>
                                {{$t('sidebar.course.name')}}
                                <i class="fa fa-angle-left right"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="permissions.createCourses">
                                <router-link :to="{name: 'CourseCreate'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.course.create')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewCourses">
                                <router-link :to="{name: 'CourseIndex'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.course.list')}}</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-item has-treeview" v-if="permissions.booksMenu">
                        <a class="nav-link">
                            <i class="nav-icon fa fa-book"></i>
                            <p>
                                {{$t('sidebar.book.name')}}
                                <i class="fa fa-angle-left right"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="permissions.createBooks">
                                <router-link :to="{name: 'BookCreate'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.book.create')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewBooks">
                                <router-link :to="{name: 'BookIndex'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.book.list')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.createBooksSubmissions">
                                <router-link :to="{name: 'BookSubmission'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.book.submission')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewBooksSubmissions">
                                <router-link :to="{name: 'viewEditSubmissions'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.book.edit_submission')}}</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-item has-treeview" v-if="permissions.bookbundlesMenu">
                        <a class="nav-link">
                            <i class="nav-icon fa fa-book"></i>
                            <p>
                                {{$t('sidebar.bookBundle.name')}}
                                <i class="fa fa-angle-left right"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="permissions.createBookbundles">
                                <router-link :to="{name: 'BookBundleCreate'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.bookBundle.create')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewBookbundles">
                                <router-link :to="{name: 'BookBundleIndex'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.bookBundle.list')}}</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-header" v-if="permissions.invoicesMenu">
                        <h3>{{$t('sidebar.invoice.heading')}}</h3>
                    </li>

                    <li class="nav-item" v-if="permissions.viewInvoices">
                        <router-link :to="{name: 'InvoiceIndex'}" class="nav-link">
                            <i class="nav-icon fas fa-file-invoice"></i>
                            <p>{{$t('sidebar.invoice.name')}}</p>
                        </router-link>
                    </li>

                    <li class="nav-item has-treeview" v-if="permissions.invoicesMenu">
                        <a class="nav-link">
                            <i class="nav-icon fas fa-file-invoice"></i>
                            <p>
                                {{$t('sidebar.invoice.student.name')}}
                                <i class="right fa fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="permissions.createInvoicesBatch">
                                <router-link class="nav-link" :to="{name: 'BatchInvoiceCreate'}"><i
                                        class="far fa-dot-circle nav-icon"></i>
                                        <p>{{$t('sidebar.invoice.batch')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.createInvoicesStudents">
                                <router-link class="nav-link" :to="{name: 'StudentInvoiceCreate'}"><i
                                        class="far fa-dot-circle nav-icon"></i>
                                        <p>{{$t('sidebar.invoice.student.create')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewInvoicesStudents">
                                <router-link class="nav-link" :to="{name: 'StudentInvoiceIndex'}"><i
                                        class="far fa-dot-circle nav-icon"></i>
                                        <p>{{$t('sidebar.invoice.student.list')}}</p>
                                </router-link>
                            </li>

                            <li class="nav-item" v-if="permissions.viewInvoicesStudentsPaid">
                                <router-link class="nav-link" :to="{name: 'StudentInvoicePaidIndex'}"><i
                                        class="far fa-dot-circle nav-icon"></i>
                                        <p>{{$t('sidebar.invoice.student.listPaid')}}</p>
                                </router-link>
                            </li>

                            <li class="nav-item" v-if="permissions.viewInvoicesStudentsPending">
                                <router-link class="nav-link" :to="{name: 'StudentInvoicePendingIndex'}"><i
                                        class="far fa-dot-circle nav-icon"></i>
                                        <p>{{$t('sidebar.invoice.student.listPending')}}</p>
                                </router-link>
                            </li>

                            <li class="nav-item" v-if="permissions.viewInvoicesStudentsUnpaid">
                                <router-link class="nav-link" :to="{name: 'StudentInvoiceUnpaidIndex'}"><i
                                        class="far fa-dot-circle nav-icon"></i>
                                        <p>{{$t('sidebar.invoice.student.listUnpaid')}}</p>
                                </router-link>
                            </li>

                            <li class="nav-item" v-if="permissions.viewInvoicesStudentsEmailed">
                                <router-link class="nav-link" :to="{name: 'StudentInvoiceEmailed'}"><i
                                        class="far fa-dot-circle nav-icon"></i>
                                        <p>{{$t('sidebar.invoice.student.emailed')}}</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-item has-treeview" v-if="permissions.invoicesMenu">
                        <a class="nav-link">
                            <i class="nav-icon fas fa-file-invoice"></i>
                            <p>
                                {{$t('sidebar.invoice.company.name')}}
                                <i class="fa fa-angle-left right"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="permissions.createInvoicesCompanies">
                                <router-link class="nav-link" :to="{name: 'CompanyInvoiceCreate'}"><i
                                        class="far fa-dot-circle nav-icon"></i>
                                        <p>{{$t('sidebar.invoice.company.create')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewInvoicesCompanies">
                                <router-link class="nav-link" :to="{name: 'CompanyInvoiceIndex'}"><i
                                        class="far fa-dot-circle nav-icon"></i>
                                        <p>{{$t('sidebar.invoice.company.list')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewInvoicesCompaniesPaid">
                                <router-link class="nav-link" :to="{name: 'CompanyInvoicePaidIndex'}"><i
                                        class="far fa-dot-circle nav-icon"></i>
                                        <p>{{$t('sidebar.invoice.company.listPaid')}}</p>
                                </router-link>
                            </li>

                            <li class="nav-item" v-if="permissions.viewInvoicesCompaniesUnpaid">
                                <router-link class="nav-link" :to="{name: 'CompanyInvoiceUnpaidIndex'}"><i
                                        class="far fa-dot-circle nav-icon"></i>
                                        <p>{{$t('sidebar.invoice.company.listUnpaid')}}</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-header" v-if="permissions.invoicesMenu">
                        <h3>{{$t('sidebar.paymentSummaries.heading')}}</h3>
                    </li>

                    <li class="nav-item has-treeview" v-if="permissions.invoicesMenu">
                        <a class="nav-link">
                            <i class="nav-icon fas fa-money-bill"></i>
                            <p>
                                {{$t('sidebar.paymentSummaries.heading')}}
                                <i class="right fa fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{name: 'PaymentSummariesIndex'}"><i
                                        class="far fa-dot-circle nav-icon"></i>
                                        <p>{{$t('sidebar.paymentSummaries.list')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" :to="{name: 'PaymentSummariesPendingIndex'}"><i
                                        class="far fa-dot-circle nav-icon"></i>
                                        <p>{{$t('sidebar.paymentSummaries.listPending')}}</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-header" v-if="permissions.importMenu">
                        <h3>{{$t('sidebar.import.heading')}}</h3>
                    </li>

                    <li class="nav-item has-treeview" v-if="permissions.importMenu">
                        <a class="nav-link">
                            <i class="fas fa-file-import nav-icon"></i>
                            <p>
                                {{$t('sidebar.import.name')}}
                                <i class="right fa fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="permissions.viewImportRecords">
                                <router-link class="nav-link" :to="{name: 'ImportRecord'}">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.import.record')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.createImportStudents">
                                <router-link class="nav-link" :to="{name: 'StudentImport'}">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.import.student')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.createImportApplications">
                                <router-link class="nav-link" :to="{name: 'StudentApplicationDocumentsImport'}">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.import.applicationDocuments')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.createImportGrades">
                                <router-link class="nav-link" :to="{name: 'GradeImport'}">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.import.grade')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.createImportGraduations">
                                <router-link class="nav-link" :to="{name: 'GraduationImport'}">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.import.graduation')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.createImportGraduations">
                                <router-link class="nav-link" :to="{name: 'StatusImport'}">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.import.status')}}</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-header" v-if="permissions.notificationsMenu">
                        <h3>{{$t('sidebar.notification.heading')}}</h3>
                    </li>

                    <li class="nav-item has-treeview" v-if="permissions.notificationsMenu">
                        <a class="nav-link">
                            <i class="fa fa-bell nav-icon"></i>
                            <p>
                                {{$t('sidebar.notification.name')}}
                                <i class="right fa fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview" style="display:none">
                            <li class="nav-item" v-if="permissions.viewNotifications">
                                <router-link class="nav-link" :to="{name: 'NotificationIndex'}">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.notification.list')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.createNotificationsBatch">
                                <router-link class="nav-link" :to="{name: 'NotificationBatchCreate'}">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.notification.create')}}</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="permissions.viewNotificationsEditor">
                                <router-link class="nav-link" :to="{name: 'NotificationEditor'}">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.notification.editor')}}</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="nav-header" v-if="permissions.settingsMenu">
                        <h3>{{$t('sidebar.setting.heading')}}</h3>
                    </li>

                    <li class="nav-item has-treeview" v-if="permissions.settingsMenu">
                        <a class="nav-link">
                            <i class="nav-icon fas fa-cog"></i>
                            <p>
                                {{$t('sidebar.setting.name')}}
                                <i class="right fa fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">

                            <li class="nav-item has-treeview" v-if="permissions.viewSettingsTuitionfee">
                                <a class="nav-link">
                                    <i class="nav-icon fas fa-dollar-sign"></i>
                                    <p>
                                        {{$t('sidebar.setting.finance.finance')}}
                                        <i class="right fa fa-angle-left"></i>
                                    </p>
                                </a>
                                <ul class="nav nav-treeview">
                                    <li class="nav-item has-treeview" v-if="permissions.createSettingsTuitionfee">
                                        <a class="nav-link">
                                            <p>
                                                <i class="far fa-dot-circle nav-icon"></i>
                                                {{$t('sidebar.setting.finance.tuitionFee')}}
                                                <i class="right fa fa-angle-left"></i>
                                            </p>
                                        </a>
                                        <ul class="nav nav-treeview">
                                            <li class="nav-item" v-if="permissions.createSettingsTuitionfee">
                                                <router-link class="nav-link" :to="{name: 'TuitionFeeCreate'}">
                                                    <i class="far fa-dot-circle nav-icon"></i>
                                                    <p>{{$t('sidebar.setting.finance.create')}}</p>
                                                </router-link>
                                            </li>
                                            <li class="nav-item" v-if="permissions.viewSettingsTuitionfee">
                                                <router-link class="nav-link" :to="{name: 'TuitionFee'}">
                                                    <i class="far fa-dot-circle nav-icon"></i>
                                                    <p>{{$t('sidebar.setting.finance.list')}}</p>
                                                </router-link>
                                            </li>
                                        </ul>
                                    </li>
                                    <li class="nav-item" v-if="permissions.viewSettingsReductiontypes">
                                        <router-link :to="{name: 'ReductionType'}" class="nav-link">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.finance.reductionTypes')}}</p>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item has-treeview">
                                <a class="nav-link">
                                    <i class="nav-icon fas fa-id-card"></i>
                                    <p>
                                        {{$t('sidebar.setting.hr.hr')}}
                                        <i class="right fa fa-angle-left"></i>
                                    </p>
                                </a>
                                <ul class="nav nav-treeview">
                                    <li class="nav-item" v-if="permissions.viewSettingsDepartments">
                                        <router-link :to="{name: 'Department'}" class="nav-link">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.hr.departments')}}</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="permissions.viewSettingsPositions">
                                        <router-link :to="{name: 'Position'}" class="nav-link">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.hr.positions')}}</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="permissions.viewSettingsHrstatuses">
                                        <router-link :to="{name: 'HrStatus'}" class="nav-link">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.hr.hrStatus')}}</p>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item has-treeview">
                                <a class="nav-link">
                                    <i class="nav-icon fas fa-university"></i>
                                    <p>
                                        {{$t('sidebar.setting.partner.name')}}
                                        <i class="right fa fa-angle-left"></i>
                                    </p>
                                </a>

                                <ul class="nav nav-treeview">
                                    <li class="nav-item" v-if="permissions.createSettingsPartners">
                                        <router-link class="nav-link" :to="{name: 'PartnerCreate'}">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.partner.create')}}</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="permissions.viewSettingsPartners">
                                        <router-link class="nav-link" :to="{name: 'PartnerIndex'}">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.partner.list')}}</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="permissions.createSettingsCampuses">
                                        <router-link class="nav-link" :to="{name: 'CampusCreate'}">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.campus.create')}}</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="permissions.viewSettingsCampuses">
                                        <router-link class="nav-link" :to="{name: 'CampusIndex'}">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.campus.list')}}</p>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item has-treeview">
                                <a class="nav-link">
                                    <i class="nav-icon fas fa-certificate"></i>
                                    <p>
                                        {{$t('sidebar.setting.registrar.registrar')}}
                                        <i class="right fa fa-angle-left"></i>
                                    </p>
                                </a>
                                <ul class="nav nav-treeview">

                                    <li class="nav-item" v-if="permissions.viewSettingsGradingscale">
                                        <router-link :to="{name: 'GradingScaleTypes'}" class="nav-link">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.registrar.gradingScaleTypes')}}</p>
                                        </router-link>
                                    </li>
                                    
                                    <li class="nav-item has-treeview" v-if="permissions.viewSettingsGradingscale">
                                        <a class="nav-link">
                                            <p>
                                                <i class="far fa-dot-circle nav-icon"></i>
                                                {{$t('sidebar.setting.registrar.gradingScale')}}
                                                <i class="right fa fa-angle-left"></i>
                                            </p>
                                        </a>
                                        <ul class="nav nav-treeview">
                                            <li class="nav-item" v-if="permissions.viewSettingsGradingscale">
                                                <router-link class="nav-link" :to="{name: 'GradingScaleCreate'}">
                                                    <i class="far fa-dot-circle nav-icon"></i>
                                                    <p>{{$t('sidebar.setting.registrar.create')}}</p>
                                                </router-link>
                                            </li>
                                            <li class="nav-item" v-if="permissions.viewSettingsGradingscale">
                                                <router-link class="nav-link" :to="{name: 'GradingScaleIndex'}">
                                                    <i class="far fa-dot-circle nav-icon"></i>
                                                    <p>{{$t('sidebar.setting.registrar.list')}}</p>
                                                </router-link>
                                            </li>
                                        </ul>
                                    </li>
                                    
                                    <li class="nav-item" v-if="permissions.viewSettingsProgramcodestypes">
                                        <router-link :to="{name: 'ProgramCodeType'}" class="nav-link">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.registrar.programCodesTypes')}}</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="permissions.viewSettingsProgramtranscripttitle">
                                        <router-link :to="{name: 'ProgramTranscriptTitle'}" class="nav-link">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.registrar.transcriptTitle')}}</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="permissions.viewSettingsProgramspecializationsmajors">
                                        <router-link :to="{name: 'SpecializationMajor'}" class="nav-link">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.registrar.specializationMajor')}}</p>
                                        </router-link>
                                    </li>                   
                                    <li class="nav-item" v-if="permissions.viewSettingsStatuses">
                                        <router-link :to="{name: 'Status'}" class="nav-link">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.registrar.statusManagement')}}</p>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item has-treeview">
                                <a class="nav-link">
                                    <i class="nav-icon fas fa-lock"></i>
                                    <p>
                                        {{$t('sidebar.setting.security.security')}}
                                        <i class="right fa fa-angle-left"></i>
                                    </p>
                                </a>
                                <ul class="nav nav-treeview">
                                    <li class="nav-item" v-if="permissions.viewSettingsAudits">
                                        <router-link class="nav-link" :to="{name: 'AuditIndex'}">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                                <p>{{$t('sidebar.setting.security.auditLog')}}</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="permissions.viewSettingsApitokens">
                                        <router-link class="nav-link" :to="{name: 'ApiTokens'}">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                                <p>{{$t('sidebar.setting.security.apiTokens')}}</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="permissions.viewSettingsLockedrecords">
                                        <router-link class="nav-link" :to="{name: 'LockedRecord'}">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.security.lockRecords')}}</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="permissions.viewSettingsLoginlist">
                                        <router-link :to="{name: 'LoginList'}" class="nav-link">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.security.loginList')}}</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="permissions.viewSettingsIps">
                                        <router-link class="nav-link" :to="{name: 'IpIndex'}">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.security.manageIP')}}</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="permissions.viewSettingsGoogle2fa">
                                        <router-link class="nav-link" :to="{name: 'Google2FA'}">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.security.manage2fa')}}</p>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>

                            <li class="nav-item has-treeview">
                                <a class="nav-link">
                                    <i class="nav-icon fas fa-user"></i>
                                    <p>
                                        {{$t('sidebar.setting.users.users')}}
                                        <i class="right fa fa-angle-left"></i>
                                    </p>
                                </a>

                                <ul class="nav nav-treeview">
                                    <li class="nav-item" v-if="permissions.createSettingsUsers">
                                        <router-link class="nav-link" :to="{name: 'UserCreate'}">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.users.create')}}</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="permissions.viewSettingsUsers">
                                        <router-link class="nav-link" :to="{name: 'UserIndex'}">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.users.list')}}</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="permissions.viewSettingsRoles">
                                        <router-link class="nav-link" :to="{name: 'RoleIndex'}">
                                            <i class="far fa-dot-circle nav-icon"></i>
                                            <p>{{$t('sidebar.setting.users.roles')}}</p>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>

                        </ul>
                    </li>

                    <li class="nav-header" v-if="user.authenticate_by == 'local'">
                        <h3>{{$t('form.setting.changePassword')}}</h3>
                    </li>

                    <li class="nav-item has-treeview" v-if="user.authenticate_by == 'local'">
                        <a class="nav-link">
                            <i class="nav-icon fas fa-lock"></i>
                            <p>
                                {{$t('sidebar.setting.users.password')}}
                                <i class="right fa fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="user.authenticate_by == 'local'">
                                <router-link :to="{name: 'ChangePassword'}" class="nav-link">
                                    <i class="far fa-dot-circle nav-icon"></i>
                                    <p>{{$t('sidebar.setting.users.updatePassword')}}</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>

                </ul>
            </nav>
            <!-- /.sidebar-menu -->
        </div>
        <!-- /.sidebar -->
    </aside>
</template>

<script>
    export default {
        props: ["permissions", "user"],

        computed: {
            partnerID() {
                return this.user.partner_id;
            }
        }
    };

</script>
